import searchplaceByGeoCode from './searchPlacByGeocode';

export const fetchGeocodeData = async (
  address: string
): Promise<
  | {
      latLng: google.maps.LatLng;
      addressComponents: google.maps.GeocoderAddressComponent[];
      formattedAddress: string;
    }
  | undefined
> => {
  try {
    const results: google.maps.GeocoderResult[] | undefined =
      await searchplaceByGeoCode(address);
    if (results && results.length > 0 && results[0]) {
      const latLng = results[0].geometry.location;
      const addressComponents = results[0].address_components;
      const formattedAddress = results[0].formatted_address;
      return { latLng, addressComponents, formattedAddress };
    }
  } catch (error) {
    console.error('Error fetching geocode data:', error);
  }
  return undefined;
};
